import { connect } from 'react-redux';
import { compose } from 'recompose';
import { activeShopPaymentDepositsEnabled } from '../../../../auth/selectors';
import withNewDesignStyles from '../../../../common/hoc/withNewDesignStyles';
import { fetchServiceSalesMetric } from '../../metrics/actions';
import {
  getCancellationsAmount,
  getCancellationsCount,
  getItemsServiceChart,
  getItemsServiceMostBooked,
  getNoShowsAmount,
  getNoShowsCount,
  getServiceSecuredDepositsAmount,
  getServiceSecuredDepositsCount,
  getServiceSalesFees,
  getServiceSalesGrossDiscounts,
  getServiceSalesGrossRefunds,
  getServiceSalesGrossTotal,
  getServiceSalesLoanRepayment,
  getServiceSalesNetTotal,
  getServiceSalesTaxes,
  getServiceSalesTips,
  getServiceSalesTotalCollected,
  getServiceSales,
  getUnchargedCount,
  getUnchargedAmount,
  getServiceSalesTaxBreakdown,
} from '../../metrics/selectors';

const SalesByServiceContainer = compose(
  withNewDesignStyles,
  connect(
    state => ({
      canceledAppointmentsCount: getCancellationsCount(state),
      canceledAppointmentsAmount: getCancellationsAmount(state),
      discounts: getServiceSalesGrossDiscounts(state),
      fees: getServiceSalesFees(state),
      grossSales: getServiceSalesGrossTotal(state),
      mostBookedServices: getItemsServiceMostBooked(state),
      netSales: getServiceSalesNetTotal(state),
      noShowAppointmentsCount: getNoShowsCount(state),
      noShowAppointmentsAmount: getNoShowsAmount(state),
      serviceSecuredDepositsAmount: getServiceSecuredDepositsAmount(state),
      serviceSecuredDepositsCount: getServiceSecuredDepositsCount(state),
      unchargedAppointmentsCount: getUnchargedCount(state),
      unchargedAppointmentsAmount: getUnchargedAmount(state),
      servicesChartData: getItemsServiceChart(state),
      shop: state.auth.shop,
      refunds: getServiceSalesGrossRefunds(state),
      taxes: getServiceSalesTaxes(state),
      tips: getServiceSalesTips(state),
      totalCollected: getServiceSalesTotalCollected(state),
      loanRepayment: getServiceSalesLoanRepayment(state),
      serviceSales: getServiceSales(state),
      taxBreakdown: getServiceSalesTaxBreakdown(state),
      paymentDepositsEnabled: activeShopPaymentDepositsEnabled(state),
    }),
    {
      fetchServiceSalesMetric,
    }
  ),
);

export default SalesByServiceContainer;
